<template>
  <div class="gemini-n-container">
    <single-mod :mod="curMod" :valueOp="valueOp" :rightEchart="rightEchart" :up-fn="upChart">
      <template v-slot="wsData">
        <div
          class="device-info"
          v-if="
            wsData.singleDeviceDetail &&
            wsData.singleDeviceDetail.mods &&
            wsData.singleDeviceDetail.mods[curMod]
          "
        >
          <el-row :gutter="100">
            <el-col :span="12" class="device-state">
              <span>设备状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.state | stateClass(true)">
                {{ wsData.singleDeviceDetail.state | stateText }}
              </span>
            </el-col>
            <el-col :span="12" class="device-state">
              <span>运行状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.runstate | runstateClass(true)">
                {{ wsData.singleDeviceDetail.runstate | runstateText }}
              </span>
            </el-col>
            <el-col :span="24">
              <div class="state-icon">
                <ModsIcon
                  icon="icon-chemical-weapon"
                  :wsData="wsData.singleDeviceDetail"
                  :mods="curMod"
                />
              </div>
            </el-col>
            <el-col :span="24">
              <div class="info">
                <div>
                  <span>测量时间:</span>
                  <span>{{ getMT(wsData.singleDeviceDetail) }}</span>
                </div>
                <div>
                  <span>存活时间:</span>
                  <span>{{ getLiveTime(wsData.singleDeviceDetail) }}</span>
                </div>
                <div>
                  <span>实际时间:</span>
                  <span>{{ getRealTime(wsData.singleDeviceDetail) }}</span>
                </div>
                <div>
                  <span>经纬度:</span>
                  <span>{{ getCoordinate(wsData.singleDeviceDetail) }}</span>
                </div>
                <div>
                  <span>设备名称:</span>
                  <span>{{ wsData.singleDeviceDetail.name }}</span>
                </div>
                <div>
                  <span>设备编号:</span>
                  <span>{{ wsData.singleDeviceDetail.sn }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </single-mod>
  </div>
</template>

<script>
import SingleMod from '../components/single-mod';
import ModsIcon from '@/components/mods-icon';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { concentrations } from '@/utils/dict';
import { formatTimestamp, throughTime } from '@/utils/utils';

export default {
  name: 'HTDevice',
  components: {
    SingleMod,
    ModsIcon
  },
  data() {
    return {
      curMod: 'nuclearMod',
      concentrations,
      list: [
        {
          title: '设备名称',
          formate: row => row
        }
      ],
      valueOp: [
        {
          title: 'γ剂量率(μSv/h)',
          key: 'radDose'
        },
        {
          title: '核素名称',
          key: 'nuclideNames'
        }
      ],
      rightEchart: [
        lineAreaStyle({
          color: '#833BBB',
          title: { text: 'γ剂量率(μSv/h)', left: 'center' },
          // yAxis: { name: 'V' },
          series: [
            { areaStyle: { color: graColor('rgba(131, 59, 187, 0.5)', 'rgba(131, 59, 187, 0)') } }
          ]
        }),
        lineAreaStyle({
          color: '#3D68E3',
          title: { text: '能谱', left: 'center' },
          xAxis: { type: 'category' },
          // yAxis: { name: 'V' },
          series: [{ areaStyle: { color: graColor('rgb(61, 104, 227)', 'rgba(0, 36, 254, 0.2)') } }]
        })
      ]
    };
  },
  methods: {
    getCoordinate({ mods }) {
      const { longitude, latitude } = mods[this.curMod];
      return `${longitude}, ${latitude}`;
    },
    getMT(t) {
      const { beginTime } = t;
      return formatTimestamp(beginTime);
    },
    getLiveTime({ mods }) {
      const { liveTime } = mods[this.curMod];
      return throughTime(liveTime);
    },
    getRealTime({ mods }) {
      const { realTime } = mods[this.curMod];
      return throughTime(realTime);
    },
    upChart(newVal) {
      const { beginTime, mods } = newVal;
      const { radDose, spectrumTracks } = mods[this.curMod];
      this.rightEchart[1].series[0].data = spectrumTracks;
      this.rightEchart[0].series[0].data.push([beginTime, radDose]);
      if (this.rightEchart[0].series[0].data.length > 20) {
        this.rightEchart[0].series[0].data.shift();
      }
    }
  }
};
</script>

<style lang="scss">
.gemini-n-container {
  height: 100%;
  .device-info {
    color: #00a0e9;
    font-size: 14px;
    .state {
      @include state-textstyle;
    }
    .device-state {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }
    .state-icon {
      margin: 20px 0;
      display: flex;
      justify-content: center;
      font-size: 26px;
    }
    .info {
      & > div {
        margin: auto;
        width: 350px;
        text-align: left;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        & > span:first-of-type {
          margin-right: 10px;
          display: inline-block;
          text-align: justify;
          text-align-last: justify;
          width: 84px;
        }
      }
    }
    .el-row {
      > .el-col {
        > div {
          line-height: 22px;
          span {
            &:first-child {
              letter-spacing: 2px;
            }
          }
        }
      }
    }
  }
}
</style>
